/* @ngInject */
import CompareComponent, {CompareTemplate} from '../components/compare/compare.component';

export default function QueueController($scope, $rootScope, $location, $timeout, $uibModal, $log, UniquePartModelService, UniquePartApiService,
                                        NotifyingService, SpinnerLoadingService, CacheService, QueryApiService, SleuthService) {
    $scope.checkedItems = [];
    $scope.browsingQueues = UniquePartModelService.getCompareQueue();
    $scope.isCompareQueueDisplayed = false;
    $scope.showCompareQueue = false;
    $scope.isDisabled = true;

    var COMPARISON_LIMIT = 3;
    var search = $location.search()['search'];
    var searchedDefId = $location.search()['searchedDefId'];
    var item0 = $location.search()['item0'];
    var item1 = $location.search()['item1'];
    var item2 = $location.search()['item2'];

    if ($scope.browsingQueues.length > 0) {
        $scope.showCompareQueue = true;
    }

    if (item0 && item0 != 'Search') {
        SpinnerLoadingService.showLoading();
        var parts = [];
        parts.push(item0);

        if (item1) {
            parts.push(item1);
        }

        if (item2) {
            parts.push(item2);
        }

        UniquePartApiService.getUniqueParts(parts, function (requests) {
            // Limit to three part number comparisons.
            for (var i = 0; i < COMPARISON_LIMIT; ++i) {
                if (requests[i] !== undefined && typeof requests[i] === 'object') {
                    UniquePartModelService.addComparison(requests[i].data);
                }
            }

            var modalInstance = $uibModal.open({
                controller: CompareComponent.name,
                templateUrl: CompareTemplate,
                scope: $scope,
                size: 'lg',
                resolve: {}
            });

            SpinnerLoadingService.hideLoading();
            modalInstance.result.then(function (selectedItem) {
                //console.log(selectedItem);
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        }, function (error) {
            console.log(error);
        });
    }

    if (item0 && item0 === 'Search' && search) {
        SpinnerLoadingService.showLoading();

        CacheService.storeOriginalQueryInput(search);

        var sleuthQuery = {
            input: search,
            targetMfgs: []
        };

        QueryApiService.executeQueryByRaw(sleuthQuery, function (result) {
            SleuthService.storeSleuthData(result);
            var parts = [];

            if (item1) {
                parts.push(item1);
            }

            if (item2) {
                parts.push(item2);
            }

            UniquePartApiService.getUniqueParts(parts, function (requests) {
                // Add comparable Search
                UniquePartModelService.addComparison(SleuthService.getSleuthDataFauxPart(searchedDefId));
                // Limit to two part number comparisons, because we have a search too.
                for (var i = 0; i < (COMPARISON_LIMIT - 1); ++i) {
                    if (requests[i] !== undefined && typeof requests[i] === 'object') {
                        UniquePartModelService.addComparison(requests[i].data);
                    }
                }

                var modalInstance = $uibModal.open({
                    controller: CompareComponent.name,
                    templateUrl: CompareTemplate,
                    scope: $scope,
                    size: 'lg',
                    resolve: {}
                });

                SpinnerLoadingService.hideLoading();

                modalInstance.result.then(function (selectedItem) {
                    //console.log(selectedItem);
                }, function () {
                    $log.info('Modal dismissed at: ' + new Date());
                });
            }, function (error) {
                console.log(error);
            });
        });
    }

    $scope.$watchCollection('browsingQueues', function (newQueues, oldQueues) {
        $scope.isDisabled = newQueues.length <= 1;

        if (newQueues.length > 0) {
            $scope.showCompareQueue = true;
            if (document.getElementsByTagName('main').length > 0) {
                document.getElementsByTagName('main')[0].classList.add('breathe');
            }
        } else {
            $scope.showCompareQueue = false;
            if (document.getElementsByTagName('main').length > 0) angular.element(document.getElementsByTagName('main')).removeClass('breathe');
        }

    });

    $scope.displayComparisonQueue = function () {
        $scope.isCompareQueueDisplayed = $scope.checkedItems.length >= 1;
    };

    $scope.compare = function () {
        var modalInstance = $uibModal.open({
            controller: CompareComponent.name,
            templateUrl: CompareTemplate,
            scope: $scope,
            size: 'lg',
            resolve: {}
        });

        modalInstance.result.then(function (selectedItem) {
            // console.log(selectedItem);
        }, function () {
            $log.info('Modal dismissed at: ' + new Date());
        });
    };

    $scope.hideCompareQueue = function () {
        $scope.showCompareQueue = false;

        for (var i = $scope.browsingQueues.length; i--;) {
            $scope.browsingQueues[i].isClicked = false;
        }
        $scope.browsingQueues.length = 0;
    };

    $scope.onRemove = function (item) {
        item.isClicked = false;
        if ($scope.browsingQueues.length === 0) {
            $scope.showCompareQueue = false;
        }
    };

    $scope.removeDetectedSearch = function () {
        var compareQueue = $scope.browsingQueues;
        for (var i = 0; i < compareQueue.length; i++) {
            if (compareQueue[i].type !== undefined) {
                $scope.onRemove(compareQueue[i]);
            }
        }
    };

    NotifyingService.subscribeToNullSleuthResult($scope, $scope.removeDetectedSearch());
}
